<template>
    <div>
        <g-level
            v-for="(item, index) in products"
            :key="item.id + index"
            class="g-mb-5"
        >
            <g-level-item class="product-image-wrapper">
                <img :src="imageUrl(item)" :alt="productName(item)" class="product-image-card">
            </g-level-item>
            <g-level-item>
                <div style="margin-left: 8px;">
                    <g-typography tag="h4" :value="productName(item)" />
                    <g-typography v-if="variantString" :value="variantString(order.items[index])" tag="p" color="secondary" />
                </div>
            </g-level-item>
        </g-level>
    </div>
</template>

<script>
    import {get} from 'lodash';

    export default {
        name:  'ProductSelectedPreview',
        props: {
            order: {
                type:     Object,
                required: true,
            },
            products: {
                type:     Array,
                required: true,
            },
        },
        methods: {
            imageUrl(product) {
                if(get(product, 'image', false)) {
                    return product.image;
                }
                return 'https://d1igyfcg6nq1cr.cloudfront.net/placeholder/placeholder-square.jpg';
            },
            productName(product) {
                if(get(product, 'name', false)) {
                    return product.name;
                }
                return 'No product name';
            },
            variantString(orderItem) {
                if(get(orderItem, 'option_values', false)) {
                    return orderItem.option_values.map(item => item.label).join(', ');
                }
                return false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .product-image-card {
        max-width: 64px;
        max-height: 64px;
        height: auto;
        width: auto;
        object-fit: cover;
    }
    .product-image-wrapper {
        width: 64px;
        height: 64px;
        border-radius: $g-border-radius-sm;
    }
</style>
